import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <h4 className="font-heading text-lg font-semibold text-background-50 mb-4">草榴论坛</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              草榴论坛入口导航与使用指南，为您提供最新、最全面的论坛访问信息和使用教程。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/zonghe-jiaoliu" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  版块浏览
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">热门版块</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category/zonghe-jiaoliu" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  综合交流
                </Link>
              </li>
              <li>
                <Link to="/category/jishu-taolun" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  技术讨论
                </Link>
              </li>
              <li>
                <Link to="/category/ziyuan-fenxiang" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  资源分享
                </Link>
              </li>
              <li>
                <Link to="/category/xinren-zhuanqu" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  新人专区
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系方式</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-sm"></i>
                </span>
                <span>contact@caoliu-guide.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-shield-check-line text-sm"></i>
                </span>
                <span>安全可靠 · 持续更新</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 草榴论坛入口指南. 本站为第三方导航网站，与草榴论坛官方无直接关联。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200" rel="nofollow">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}